import { createOnitClientFromEnv } from '@cafe-pos/supabase';

/**
 * Singleton Supabase client built from the dashboard's Vite env.
 * Null when VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set — the UI
 * then renders a "not configured" notice instead of crashing.
 */
export const supabase = createOnitClientFromEnv(
  import.meta.env as Record<string, string | undefined>,
);

export const isSupabaseConfigured = supabase !== null;
